import React from "react";
import Loader from "../../../../assets/images/loader.svg";
import LogoEmpresa from "../../../../assets/images/seguros-logo.svg";
import "./Loading.scss";

const Loading = () => {
  return (
    <div className="loading__container">
      <div className="loading d-flex justify-content-center align-self-center align-items-center">
        {/* Contenedor del spinner */}
        <div className="loading__spinner-container">
          {/* Logo con fondo redondeado dentro del spinner */}
          <div className="loading__logo-container">
            <img
              alt="Logo Seguros Atlántida"
              src={LogoEmpresa}
              className="loading__logo"
            />
          </div>
          <img alt="Loader Spinner" src={Loader} className="loading__spinner" />
        </div>
        <h3 className="loading__legend">Procesando...</h3>
      </div>
    </div>
  );
};

export default Loading;
